import EBarContentResourcesListBlock from './EBarContentResourcesListBlock';

export default EBarContentResourcesListBlock;
